export default "__VITE_ASSET__D5cQLYD$__"